import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Client } from '@/types/client';
import { Modal } from '@/types/modal';
import Grid, { itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import ModalView from '@/components/modals/Modal';
import { Label } from '@/components/atoms/Section';
import { useClipboardCopy } from '@/hooks/common';
import ClipboardSnackbar from '@/components/molecules/common/ClipboardSnackbar';

const View: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();
  const [modal, setModal] = useState<Modal | null>(null);

  const { copy, onSnackbarClose, snackbarOpen } = useClipboardCopy();

  const items = [
    itemText(
      <Label labelInfo={{ label: t('client.contact_info.email'), onCopy: () => copy(client.email) }} />,
      client.email,
      {
        kind: 'Button',
        label: t('common.update').toUpperCase(),
        onClick: () => setModal({ kind: 'UpdateEmail', client, onClose: () => setModal(null) }),
      },
    ),
    itemText(t('client.contact_info.billing_address'), client.address),
    itemText(t('client.contact_info.billing_phone_number'), client.phone),
    itemText(t('client.contact_info.company_name_b2c'), client.companyName),
  ];

  return (
    <>
      <Container
        title={t('client.contact_info.title')}
        actions={[]}
        testId="contact_info"
      >
        <Grid
          column={5}
          items={items}
        />
      </Container>
      <ModalView modal={modal} />

      <ClipboardSnackbar
        open={snackbarOpen}
        onClose={onSnackbarClose}
      />
    </>
  );
};

export default View;
